import * as THREE from 'three'
import * as ZapparThree from '@zappar/zappar-threejs'

import FS from './fragment'
import VS from './vertex'

class ShaderMaterial extends THREE.ShaderMaterial {
  public constructor() {
    super({
      uniforms: {
        uCameraTexture: { value: new THREE.Texture() },
        uCameraTextureMatrix: { value: new THREE.Matrix4() },
        uResolution: { value: new THREE.Vector3() },
      },
      vertexShader: VS,
      fragmentShader: FS,
    })
  }

  public render(camera: ZapparThree.Camera, renderer: THREE.WebGLRenderer) {
    const { backgroundTexture } = camera

    this.uniforms.uCameraTexture.value = backgroundTexture
    this.uniforms.uCameraTextureMatrix.value = backgroundTexture.matrix

    this.uniforms.uResolution.value.set(
      renderer.domElement.width,
      renderer.domElement.height
    )

    this.uniformsNeedUpdate = true
  }
}

class CopyPass {
  private renderTargetCamera = new THREE.OrthographicCamera(
    -1,
    1,
    1,
    -1,
    0.01,
    1
  )

  private renderTargetScene = new THREE.Scene()

  private shaderMaterial = new ShaderMaterial()

  private quad = new THREE.Mesh(
    new THREE.PlaneBufferGeometry(2, 2),
    this.shaderMaterial
  )

  private renderTarget = new THREE.WebGLRenderTarget(
    window.innerWidth,
    window.innerHeight,
    {
      minFilter: THREE.LinearFilter,
      magFilter: THREE.LinearFilter,
      format: THREE.RGBAFormat,
    }
  )

  public get texture() {
    this.renderTarget.texture.encoding = THREE.sRGBEncoding
    this.renderTarget.texture.format = THREE.RGBAFormat

    return this.renderTarget.texture
  }

  public constructor(private zapparCamera: ZapparThree.Camera) {
    this.renderTargetScene.add(this.renderTargetCamera)
    this.renderTargetScene.add(this.quad)
    this.renderTargetScene.background = zapparCamera.backgroundTexture
  }

  public render = (renderer: THREE.WebGLRenderer) => {
    this.shaderMaterial.render(this.zapparCamera, renderer)

    this.renderTarget.setSize(
      renderer.domElement.width * renderer.getPixelRatio(),
      renderer.domElement.height * renderer.getPixelRatio()
    )

    renderer.setRenderTarget(this.renderTarget)
    renderer.render(this.renderTargetScene, this.renderTargetCamera)
    renderer.setRenderTarget(null)
  }
}

export default CopyPass
